import { runAfterInitialRender } from 'owa-delayed-initialization';
import initPopImapConfiguration from './actions/initPopImapConfiguration';
// Load initial state needed for options
runAfterInitialRender(function () {
    initPopImapConfiguration();
});
export { default as savePopImapConfiguration } from './actions/savePopImapConfiguration';
export { default as getPopImapConfiguration } from './utils/getPopImapConfiguration';
export { default as initPopImapConfiguration } from './actions/initPopImapConfiguration';
//# sourceMappingURL=index.js.map